import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[conditionalMenuTrigger]',
})
export class ConditionalMenuTriggerDirective {
  @Input() conditionalMenuTrigger: boolean;

  @HostListener('click', ['$event'])
  handleClick(event: Event): void {
    if (this.conditionalMenuTrigger) {
      event.stopImmediatePropagation();
    }
  }
}
